import styled from 'styled-components';

import { Spacing } from '@ninox/ninox-components/theme';

export const Row = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${Spacing.medium};
`;
